import React, { useContext } from 'react';
import { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import useClickOutside from "./useClickOutside";
import config from "../config";
import UpcommingFixture from './UpcommingFixture';
import { GlobalContext } from '../global/GlobalProvider';
import { useTranslation } from 'react-i18next';


function Sidebar() {
   const { t, i18n } = useTranslation();
   const [activeMenu, setActiveMenu] = useState('');
   const [seriesMenu, setSeriesMenu] = useState('');
   const initialized = useRef(false);
   const [mainFilteredMatch, setMainFilteredMAtch] = useState([]);

   const [mainMenu, setMainMenu] = useState([]);
   const [allSport, setAllSport] = useState();
   const [menuList, setMenuList] = useState();
   const [countArray, setCountArray] = useState([]);
   let filterredData = [];
   const navigate = useNavigate();
   const [racingMenu, setRacingMenu] = useState(null);
   const dropdownRefs = useRef({});
   const { setMobileMenu,isMobileMenuOpen,loggedIn } = useContext(GlobalContext);
   const [searchTerm, setSearchTerm] = useState("");
  const [filteredSports, setFilteredSports] = useState([]);

   // Toggle function to open/close dropdown
   const toggleDropdown = (sportId) => {
      setRacingMenu(prev => (prev === sportId ? null : sportId)); // Close if already open, else open
   };

   useEffect(() => {
      if (!searchTerm.trim()) {
        setFilteredSports([]);
        return;
      }

      const filtered = mainFilteredMatch
        .map((sport) => {
          const matches = sport.sportData.filter((match) =>
            match.eventName.toLowerCase().includes(searchTerm.toLowerCase())
          );

          if (matches.length > 0) {
            return {
              sport_type: sport.sport_type,
              sportData: matches
            };
          }
          return null;
        })
        .filter(Boolean); // Remove nulls

      setFilteredSports(filtered);
    }, [searchTerm,mainFilteredMatch]);



   const transformSelectedSportsData = async (apiResponse) => {
      const result = [];

      // Only include "All Sport" and "Racing Sports"
      const filteredTypes = ["All Sport", "Racing Sports"];

      apiResponse?.data?.forEach((category) => {
        if (filteredTypes.includes(category.type)) {
          category.sport_Type.forEach((sport) => {
            const allMatchData = [];

            // Flatten all matchdata from each series
            sport.sportData.forEach((series) => {
              series?.matchdata?.forEach((match) => {
                allMatchData.push(match);
              });
            });

            result.push({
              sport_type: sport.sport_type,
              sportData: allMatchData
            });
          });
        }
      });

      return result;
    };


   // Close dropdown when clicking outside
   useClickOutside(dropdownRefs, () => setRacingMenu(null));
   const getMenuAPICall = () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/getSideMenuNew`,
        requestOptions
      )
        .then(async (response) => {
            let paresData = await response.json();
            setMenuList(paresData);
            setMainMenu(paresData.data.map((_, index) => index));
            setAllSport(paresData.data.find(item => item.type === "All Sport"))
            let data = await transformSelectedSportsData(paresData);
            setMainFilteredMAtch(data)
        })
        .catch((error) => {
          console.log(error);
        });
    };

   const getAllSport = () => {
      if (menuList) {
         return menuList.data.find(item => item.type !== "Racing Sports") || {};
      }else{
         return {};
      }
   }

   const getRacingSport = () => {
      if (menuList) {
         return menuList.data.find(item => item.type === "Racing Sports") || {};
      }else{
         return {};
      }
   }

    useEffect(() => {
      if (!initialized.current) {
          initialized.current = true;
          getMenuAPICall();
        }
    }, []);

    const getImageClass = (sportId) => {
      if (sportId === "1") {
         return 'd-icon icon-1';
      }else if (sportId === "4") {
         return 'd-icon icon-4';
      }else if (sportId === "2") {
         return 'd-icon icon-2';
      }else if (sportId === "400") {
         return 'd-icon icon-66';
      }else if (sportId === "500") {
         return 'd-icon icon-40';
      }else if (sportId === '8') {
       return 'd-icon icon-8';  
      }else if (sportId === '22') {
       return 'd-icon icon-22';  
      }else if (sportId === '68') {
       return 'd-icon icon-68';  
      }else if (sportId === '15') {
       return 'd-icon icon-15';  
      }else if (sportId === '18') {
       return 'd-icon icon-18';  
      }else if (sportId === '59') {
       return 'd-icon icon-59';  
      }else if (sportId === '19') {
       return 'd-icon icon-19';  
      }else if (sportId === '11') {
       return 'd-icon icon-11';  
      }else if (sportId === '9') {
       return 'd-icon icon-9';  
      }else if (sportId === '39') {
       return 'd-icon icon-39';  
      }else if (sportId === '5') {
       return 'd-icon icon-5';  
      }else if (sportId === '55') {
       return 'd-icon icon-55';  
      }else if (sportId === '71') {
       return 'd-icon icon-7';  
      }else if (sportId === '3') {
       return 'd-icon icon-3';  
      }else if (sportId === '16') {
       return 'd-icon icon-16';  
      }else if (sportId === '17') {
       return 'd-icon icon-17';  
      }else if (sportId === '29') {
       return 'd-icon icon-29';  
      }else if (sportId === '32') {
       return 'd-icon icon-32';  
      }else if (sportId === '33') {
       return 'd-icon icon-33';  
      }else if (sportId === '35') {
       return 'd-icon icon-35';  
      }else if (sportId === '37') {
       return 'd-icon icon-37';  
      }else if (sportId === '38') {
       return 'd-icon icon-38';  
      }else if (sportId === '52') {
       return 'd-icon icon-52';  
      }else if (sportId === '53') {
       return 'd-icon icon-53';  
      }else if (sportId === '54') {
       return 'd-icon icon-54';  
      }else if (sportId === '57') {
       return 'd-icon icon-57';  
      }else if (sportId === '62') {
       return 'd-icon icon-62';  
      }else if (sportId === '64') {
       return 'd-icon icon-64';  
      }else if (sportId === '67') {
       return 'd-icon icon-67';  
      }else {
         return 'd-icon icon-4';
      }
   }

   const getMainActiveColor = (sportId) => {      
      if (sportId === "1") {
         return config.ColorFootball;
      }else if (sportId === "4") {
         return config.ColorCricket;
      }else if (sportId === "2") {
         return config.ColorTenis;
      }else if (sportId === "400") {
         return config.ColorKabaddi;
      }else if (sportId === "500") {
         return config.ColorElection;
      }else if (sportId === "4339") {
         return config.ColorGreyhoundRacing;
      }else if (sportId === "7") {
         return config.ColorHorseRacing;
      }else if (sportId === '8') {
       return '#db2752';  
      }else if (sportId === '22') {
       return '#3c7a57';  
      }else if (sportId === '68') {
       return '#03b37f';  
      }else if (sportId === '15') {
       return '#fbb03b';  
      }else if (sportId === '18') {
       return '#074a60';  
      }else if (sportId === '59') {
       return '#11b24b';  
      }else if (sportId === '19') {
       return '#2f7ed5';  
      }else if (sportId === '11') {
       return '#623cea';  
      }else if (sportId === '9') {
       return '#74c94b';  
      }else if (sportId === '39') {
       return '#69306d';  
      }else if (sportId === '5') {
       return '#015900';  
      }else if (sportId === '55') {
       return '#ed5f62';  
      }else if (sportId === '71') {
       return '#ff9c63';  
      }else if (sportId === '3') {
       return '#e44e23';  
      }else if (sportId === '16') {
       return '#9fbe3c';  
      }else if (sportId === '17') {
       return '#0e345e';  
      }else if (sportId === '29') {
       return '#60a5da';  
      }else if (sportId === '32') {
       return '#bd6a58';  
      }else if (sportId === '33') {
       return '#d96c0d';  
      }else if (sportId === '35') {
       return '#e83d1a';  
      }else if (sportId === '37') {
       return '#d95b66';  
      }else if (sportId === '38') {
       return '#d592ff';  
      }else if (sportId === '52') {
       return '#a175c8';  
      }else if (sportId === '53') {
       return '#c06c84';  
      }else if (sportId === '54') {
       return '#8a101c';  
      }else if (sportId === '57') {
       return '#b21347';  
      }else if (sportId === '62') {
       return '#03b37f';  
      }else if (sportId === '64') {
       return '#623cea';  
      }else if (sportId === '67') {
       return '#2b65ec';   
      }else{
         return config.ColorCricket;
      }
   }

   const setTogalMain = (sportType) => {
      if (activeMenu === sportType) {
         setActiveMenu('');
      }
      else {
         setActiveMenu(sportType);
      }
   }

   const countAPI = () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/games/liveCountData`,
        requestOptions
      )
        .then(async (response) => {
          let paresData = await response.json();
          setCountArray([]);
          setCountArray(paresData.result);
        })
        .catch((error) => {
          console.log(error);
        });
    };

   useEffect(() => {
      // Initialize refs for each dropdown dynamically
      getRacingSport()?.sport_Type?.forEach((item) => {
         dropdownRefs.current[item.Sport_Id] = dropdownRefs.current[item.Sport_Id] || React.createRef();
      });
   }, []);

   const setSeriesClick = (sportType, index) => {
      let sMenu = `${sportType}_${index}`;
      if (seriesMenu === sMenu) {
         setSeriesMenu('');
      }
      else {
         setSeriesMenu(sMenu);
      }
   }

   const getCountByName = (type) => {
      const item = countArray.find(item => item.name.toLowerCase() === type.toLowerCase());
      return item ? item.count : 0; // return 0 or you can return `null` or `undefined` if not found
  };

  const getCount = (data)=>{
   return data.sportData.reduce((total, series) => {
      return total + series.matchdata.length;
    }, 0);
  }

  const handlebetClk = (subItem) => {
   navigate(subItem.baseUrl);
   setRacingMenu(null); // Close the dropdown after navigation
  }

  return (
    <div className={`sidebar ${isMobileMenuOpen ? 'open':''}`}>
        <div className="sidebar-box logo">
          <Link to={`/sport`}>
            <img src={localStorage.getItem("logo")} loading="lazy" alt="" />
          </Link>
        </div>

        <UpcommingFixture />
        <div className={`sidebar-box sidebar-search ${sessionStorage.getItem('loggedIn') || loggedIn ? '' : 'hide'}`}>
        <div className="sidebar-search-wraper">
        <form autoComplete="off">
        <div className="search open">
        
            <input placeholder={t('search')}
              name="custom_search"
               autoCapitalize="off"
               spellCheck="false"
               className="form-control"
               autoComplete="nope"
               type="search"
               value={searchTerm}
               onChange={(e) => setSearchTerm(e.target.value)}/>
            {searchTerm.trim().length > 0 ? '':<div className="search-icon"><img src="images/search.svg" alt="" srcSet="" /></div>}
        </div>
        </form>

        <div className={`search-list ${searchTerm.trim().length > 0 ? 'open':''}`}>
            <div className="search-title">{t('SearchResult')}</div>
            <div className="search-content">
         {filteredSports.length > 0 ? (
            filteredSports.map((sport) => (
          <div key={sport.sport_type} className='event-list'>
            <div className='search-event-title'>{sport.sport_type}</div>
            <ul>
              {sport.sportData.map((match) => (
                <li key={match.eventId} className='search-game' onClick={()=>(navigate(`/exchange_inPlay/${match.eventId}`),setSearchTerm(''),setMobileMenu(false))}>
                 <div className='search-game-name'>{match.eventName}</div>
                  {/* <div className="search-game-time">18/03/2025 05:40:00 (UTC+05:30)</div> */}
                </li>
              ))}
            </ul>
          </div>
        ))
      ) : searchTerm ? (
        <p>{t('no_result_found')}</p>
      ) : null}
        </div>
        </div>
        </div>
        <div className="menu-button-mobile" onClick={()=>setMobileMenu(!isMobileMenuOpen)}><div><span className="menu-button-bar"></span><span className="menu-button-bar"></span><span className="menu-button-bar"></span></div></div>
        </div>

      <div className="sidebar-box race-sport-menu">
         <div className="sidebar-title">{t('RacingSport')}</div>
         <div className="sidebar-content" >
         <ul className='dropdown right-position' >
         {menuList && getRacingSport().sport_Type.map((item, index) => (
            <li className='dropdown-toggle' key={index} id={index}>
               <p className='dropdown-item' onClick={() => toggleDropdown(item.Sport_Id)}
               style={{ backgroundColor: racingMenu?.toLowerCase() === item.Sport_Id.toLowerCase() ? getMainActiveColor(item.Sport_Id) : "", color: racingMenu?.toLowerCase() === item.Sport_Id.toLowerCase() ? "white" : "" }}>
                  {item.Sport_Id == 7 ? <i className="d-icon icon-10" style={{color:racingMenu?.toLowerCase() === item.Sport_Id.toLowerCase() ? "#FFFFFF" : config.ColorHorseRacing}}></i> : <i className="d-icon icon-65" ></i>}
                  {t(item.sport_type)}
               </p>
               <div ref={dropdownRefs.current[item.Sport_Id]}
                  className={`dropdown-menu ${racingMenu === item.Sport_Id ? 'show' : ''}`}>
                  <h5>{t(item.sport_type)}</h5>
                  <ul className='menu-list hourse-racing-list'>
                     {item.sportData.map((subItem, subIndex) => (
                        <li key={subIndex}>
                           <p className="dropdown-item" onClick={() =>handlebetClk(subItem) }>
                              <span>{subItem.eventName}</span>
                           </p>
                        </li>
                     ))}
                  </ul>
               </div>
            </li>
         ))}
         </ul>
         </div>
      </div>

      <div className="sidebar-box all-sport-menu">
      {allSport && allSport.sport_Type.length > 0 ? (
         <>
         <div className="sidebar-title">{t('AllSport')}</div>
         <div className="sidebar-content">
            <ul className='dropdown right-position'>
            {allSport.sport_Type.map((sport, index) => (
               <li className={`dropdown-toggle ${activeMenu.toLowerCase() === sport.sport_type.toLowerCase()?'active':''}`} key={index}>
               <p className="dropdown-item" onClick={() => setTogalMain(sport.sport_type)}
                  style={{ backgroundColor: activeMenu.toLowerCase() === sport.sport_type.toLowerCase() ? getMainActiveColor(sport.Sport_Id) : "", color: activeMenu.toLowerCase() === sport.sport_type.toLowerCase() ? "white" : "" }}>
                  <i className={getImageClass(sport.Sport_Id)} style={{ color: activeMenu.toLowerCase() === sport.sport_type.toLowerCase() ? "" : getMainActiveColor(sport.Sport_Id)}}></i> <span className='menu-name'>{t(sport.sport_type)}</span> <span className="num">({getCount(sport)})</span>
               </p>
               <div className={`dropdown-menu ${activeMenu.toLowerCase() === sport.sport_type.toLowerCase() ? 'show' : ''}`}>
                  <ul className='menu-list'>
                     {getCount(sport) != 0 ? 
                     sport.sportData.map((subItem, subIndex) => (
                        <li className={`dropdown-toggle ${seriesMenu === `${sport.sport_type}_${subIndex}` ? 'active' : ''}`} key={subIndex}>
                        <p className="dropdown-item" onClick={() => setSeriesClick(sport.sport_type,subIndex)} style={{ backgroundColor: seriesMenu === `${sport.sport_type}_${subIndex}` ? `${getMainActiveColor(sport.Sport_Id)}bf` : '', color: "white" }}><span className='menu-name'>{subItem.series}</span> <span className="num"> ({subItem.matchdata.length})</span></p>
                           <div className={`dropdown-menu ${seriesMenu === `${sport.sport_type}_${subIndex}` ? 'show' : ''}`}>
                              <ul className='menu-list menu-inner-list'>
                              {subItem.matchdata.map((match, matchIndex) => (
                                 <li key={matchIndex} id={match.eventId}>
                                    <p className="dropdown-item" onClick={() => navigate(match.baseUrl)}><span className='menu-name'>{match.eventName}</span></p>
                                 </li>
                              ))}
                              </ul>
                           </div>
                        </li>
                     )):
                     <li><p className="dropdown-item"><span className='menu-name'>{t('NoLiveEvents')}</span></p></li>
                     }
                  </ul>
               </div>
               </li>
            ))}
            </ul>
         </div>
        </>
      ) : (
        <p>No sports available</p>
      )}
      </div>
    </div>
  )
}

export default Sidebar